import { K8s, RegisterKind, kind as a, fetch, fetchStatus, kind } from "kubernetes-fluent-client";
import * as R from "ramda";

import { Capability } from "./lib/core/capability";
import Log from "./lib/telemetry/logger";
import { PeprModule } from "./lib/core/module";
import { PeprMutateRequest } from "./lib/mutate-request";
import * as PeprUtils from "./lib/utils";
import { PeprValidateRequest } from "./lib/validate-request";
import * as sdk from "./sdk/sdk";
import { metricsCollector } from "./lib/telemetry/metrics";

export {
  metricsCollector,
  Capability,
  K8s,
  Log,
  PeprModule,
  PeprMutateRequest,
  PeprUtils,
  PeprValidateRequest,
  R,
  RegisterKind,
  a,
  fetch,
  fetchStatus,
  kind,
  sdk,
};
